module.exports = __webpack_public_path__ + "static/media/adhd active.db8bd546.svg";